var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addSuccess"},[_c('span',{staticClass:"md-display-1"},[_vm._v("Akcja ukończona!")]),_c('img',{attrs:{"src":require("../assets/theMoon.svg")}}),_c('span',{staticClass:"md-subheading"},[_vm._v("Dodawanie przedmiotów zakończone sukcesem.")])])
}]

export { render, staticRenderFns }